export const MCP_CATALOG_MODE = {
    CREATE: 'create',
    EDIT: 'edit'
};

// Display prefix for a Local MCP name (e.g. "[LMCP]Local File")
export const LOCAL_MCP_LABEL_PREFIX = '[LMCP]';

// Display prefix for a Local MCP [user] / [project]
export const LOCAL_MCP_USER_PREFIX = '[U]';
export const LOCAL_MCP_PROJECT_PREFIX = '[P]';

// mcpType launch method options (must match backend McpServerConstant.MCP_CATALOG_TYPE)
export const MCP_CATALOG_TYPE_OPTIONS = [
    { id: 'NPX', label: 'NPX' },
    { id: 'PYTHON', label: 'PYTHON' },
    { id: 'DOWNLOAD', label: 'DOWNLOAD' }
];

// Supported OS options (must match backend McpServerConstant.MCP_CATALOG_SUPPORTED_OS)
export const MCP_CATALOG_OS_OPTIONS = [
    { id: 'Windows', label: 'Windows' },
    // { id: 'Mac', label: 'Mac' },
    // { id: 'Linux', label: 'Linux' }
];

export const MCP_CATALOG_FORM_DEFAULT_VALUES = {
    mcpName: '',
    mcpPackageName: '',
    mcpPackageVersion: '',
    mcpType: '',
    description: '',
    purpose: '',
    supportedOS: [],
    downloadURL: '',
    prerequisites: '',
    requiredEnv: '',
    systemPrompt: ''
};

// Number of version history (snapshot) records loaded per API call (initial + See More)
export const MCP_CATALOG_SNAPSHOT_PAGE_SIZE = 10;
